import React from 'react';
import * as StyledLocationFilter from './frontpageFilter.styles';
import FilterMenu from '../apartmentListFilters/filterMenu';
import { closeContextMenu } from '../../actions/contextMenuActions';
import Spinner from '../base/loaders/spinner';

const FrontpageLocationFilter = ({
	loading,
	error,
	values,
	selectedValues,
	setFilters,
	dispatch
}) => {
	const onSaveClick = (items) => {
		dispatch(setFilters(items));
		dispatch(closeContextMenu());
	};

	return (
		<StyledLocationFilter.Wrapper>
			{
				loading && (
					<StyledLocationFilter.SpinnerWrapper>
						<Spinner />
					</StyledLocationFilter.SpinnerWrapper>
				)
			}
			{
				!loading && !error && (
					<FilterMenu
						values={values}
						selectedValues={selectedValues}
						onSave={onSaveClick} />
				)
			}
		</StyledLocationFilter.Wrapper>
	);
};

export default FrontpageLocationFilter;
